import { Pipe, PipeTransform } from '@angular/core';

import { PcgEntry } from '@models/pcg-entry';

@Pipe({
  name: 'pcgEntryDescription',
  standalone: true
})
export class PcgEntryDescriptionPipe implements PipeTransform {
  transform(pcgEntry: PcgEntry): string | null {
    if (!pcgEntry) return null;

    return `${pcgEntry.accountNumber} - ${pcgEntry.label}`;
  }
}
